import {projectListMocks} from './GameStatisticsService.mocks';
import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {DevPanel} from '@/services/DevPanel/DevPanel';
import {GameStatisticsStore} from '@/stores/GameStatisticsStore/GameStatisticsStore';
import {Config} from '@/types';

export class GameStatisticsDevPanel {
  public isInitialized: boolean = false;
  public config: {
    ['Добавить общую статистику']: VoidFunction;
    ['Удалить общую статистику']: VoidFunction;
  };

  constructor(
    private readonly gui: DevPanel,
    private readonly configApp: Config,
    private readonly gameStatisticsStore: GameStatisticsStore,
  ) {}

  public init = (): void => {
    if (this.configApp.isProd) {
      return;
    }
    if (this.isInitialized) {
      return;
    }
    this.isInitialized = true;
    this.config = {
      ['Добавить общую статистику']: () => {
        this.gameStatisticsStore.setProjectDT(projectListMocks);
      },
      ['Удалить общую статистику']: () => {
        this.gameStatisticsStore.setProjectDT(null);
      },
    };

    const folder = this.gui.getInstance().addFolder('Statistics');

    folder.add(this.config, 'Добавить общую статистику');
    folder.add(this.config, 'Удалить общую статистику');
  };
}

injected(GameStatisticsDevPanel, DI_TOKENS.devPanel, DI_TOKENS.config, DI_TOKENS.gameStatisticsStore);
